'use client';

import { css } from '@bts-web/utils-style-engine';
import { useClientUserInfo } from '../../userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { RegularBell } from '../../svgIcons';
import { HyperLinkButtonBase } from '../HyperLinkButtonBase/HyperLinkButtonBase';

export const NotificationsBell = () => {
  const {
    notifications: { unreadCount },
  } = useClientUserInfo();

  return (
    <HyperLinkButtonBase
      to="/notification-center"
      prefetch={false}
      aria-label="view notifications"
      visual="ghost"
      size="small"
      className={css({
        lineHeight: 1,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: 'auto',
        height: 'auto',
        minWidth: '46px',
        px: {
          base: 'extra_small_2',
          lg: 'small',
        },
        py: {
          base: 'extra_small_2',
          lg: 'small',
        },
        minHeight: {
          base: '32px',
          lg: '56px',
        },
      })}
    >
      <RegularBell size={22} />

      {unreadCount > 0 && (
        <span
          data-testid="notifications-number"
          className={css({
            position: 'absolute',
            top: {
              base: '5%',
              lg: '15%',
            },
            insetInlineEnd: {
              base: '5%',
            },
            background: '#FF5252',
            borderRadius: '50%',
            color: 'white',
            width: unreadCount > 99 ? '22px' : '16px',
            height: unreadCount > 99 ? '20px' : '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 0 4px rgba(0,0,0,0.2)',
            fontSize: 'caption.small',
            letterSpacing: 'caption.small',
            lineHeight: 'caption.small',
            fontWeight: 'caption.small',
          })}
        >
          {unreadCount > 99 ? '+99' : unreadCount}
        </span>
      )}
    </HyperLinkButtonBase>
  );
};
